<div *ngFor="let faq of faqs" class="card landing-card">
  <div class="question d-flex justify-content-between cursor-pointer" (click)="click(faq)">
    <span>{{faq.question}}</span>
    <img
      src="assets/icons/{{faq.show ? 'angle-up' : 'angle-down'}}.svg"
      class="rec mr-2"
      [class.rotate]="faq.show"
      [attr.alt]="'alt.toggleFaq' | translate"
    />
  </div>
  <div class="answer" [class.show]="faq.show">
    <p class="pl-5 pt-3" [innerHTML]="faq.answer"></p>
  </div>
</div>
